import * as React from 'react';
import { RequestAppointmentHeader } from './RequestAppointmentHeader';
import { gql } from '@apollo/client';
import { RequestAppointmentHeaderFragmentDoc } from './__generated__/RequestAppointmentHeader.generated';
import { RequestAppointmentBody } from './RequestAppointmentBody';
import { RequestAppointmentFooter } from './RequestAppointmentFooter';
import { useGetShopLocationShortName } from '../lib/useGetShopLocationShortName';
import { useRequestAppointmentPageMetadataQuery } from './__generated__/RequestAppointmentPage.generated';
import { ErrorPageContainer } from 'src/Components/ErrorPage/ErrorPageContainer';
import { ErrorPageLogo } from 'src/Components/ErrorPage/ErrorPageLogo';

export interface IRequestAppointmentPageProps {}

export const RequestAppointmentPage: React.FunctionComponent<
  IRequestAppointmentPageProps
> = props => {
  const { metadata, error } = useRequestApppointmentPageMetadata();
  return (
    <>
      {!error && (
        <>
          <RequestAppointmentHeader metadata={metadata} />
          <RequestAppointmentBody />
        </>
      )}
      {error && (
        <div className='flex flex-1 flex-grow flex-col'>
          <ErrorPageContainer>
            <ErrorPageLogo href={`/`} />
            <h1 className='max-w-3xl p-3 text-center'>
              <span className='text-lg font-bold'>Oops!</span> Seems like you
              have the wrong link. Please contact the shop to get the right link
              to book an appointment.
            </h1>
          </ErrorPageContainer>
        </div>
      )}
      <RequestAppointmentFooter />
    </>
  );
};

function useRequestApppointmentPageMetadata() {
  const locationShortName = useGetShopLocationShortName();
  const { data, loading, error } = useRequestAppointmentPageMetadataQuery({
    variables: {
      locationShortName: locationShortName || '',
    },
    skip: !locationShortName,
  });
  return { metadata: data?.requestAppointmentPageMetadata, loading, error };
}

const query = gql`
  query RequestAppointmentPageMetadata($locationShortName: String!) {
    requestAppointmentPageMetadata(locationShortName: $locationShortName) {
      ...RequestAppointmentHeader
    }
    ${RequestAppointmentHeaderFragmentDoc}
  }
`;
